import { render, staticRenderFns } from "./CQuotationPrintView.vue?vue&type=template&id=41004e83&scoped=true"
import script from "./CQuotationPrintView.vue?vue&type=script&lang=ts"
export * from "./CQuotationPrintView.vue?vue&type=script&lang=ts"
import style0 from "./CQuotationPrintView.vue?vue&type=style&index=0&id=41004e83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41004e83",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
